import { Providers } from './app/providers';
import { VersionSwitch } from './app/version-switch';

export default function App() {
  return (
    <Providers>
      <VersionSwitch />
    </Providers>
  );
}
